import { connect } from 'react-redux';
import ScribeLoginProfiling from './ScribeLoginProfiling';

import {
  fetchFeatureFlag,
} from '../../actions';

const mapStateToProps = state => ({
  firebaseUser: state.firebase.user,
})

export default connect(
  mapStateToProps,
  {fetchFeatureFlag}
)(ScribeLoginProfiling);
